define('home/models/activities/AnnouncementActivity',[
    'home/models/Activity',
    'home/activityExpander',
], function (
    Activity,
    activityExpander
) {
    'use strict';

    /**
     * A system message for end users
     *
     * Relations {
     *     object: {
     *         type: 'Announcement',
     *         description: 'The contents of the announcement'
     *     }
     * }
     */
    return Activity.extend({
        defaults: {
            verb: 'send',
        },

        initialize: function (attributes) {
            this.object = attributes.object;
        },

        parseRelatedModels: function (attributes, objects) {
            attributes.object = activityExpander.buildAnnouncement(objects, attributes.object);
            return attributes;
        },
    });
});

